import { Image } from "primereact/image";
import resetButton from "../../assets/svg/key_icon.svg"

export default function ResetPasswordButton() {
    return (
        <Image src={resetButton}  />

    )
}
